<style media="screen" type="text/css">

.return-box {
  border: 2px solid #6D7C8E;
  box-sizing: border-box;
  border-radius: 20px;
  width: 175px;
}

.balance-box-2 {
  border: 2px solid #1DC895;
  box-sizing: border-box;
  border-radius: 20px;
  min-width: 220px;
}
</style>

<template>
  <div>
    <v-row>
      <v-col class="custome-form" md="4">
        <label>{{ $lang.SELECT_WHOLESALER }}</label>
        <wholesaler-select-box :is_withdraw="true"
                               :wholesaler="$store.state.initiate_withdrawal.wholesaler"
                               @update-wholesaler="getWholesaler"/>
      </v-col>
      <v-col class="text-right" md="8">
        <v-btn color="primary "
               depressed
               @click="initiateWithdrawal">
          <b>{{ $lang.WITHDRAW }}</b>
        </v-btn>
      </v-col>

    </v-row>

    <div>
      <!-- return card -->
      <div class="d-inline-block return-box pa-4 ">
        <p class="secodry-text-2 fs-14">{{ $lang.TOTAL_RETURNS }}</p>
        <p class="secodry-text-2 fw-800 fs-36">{{ return_count }}</p>
      </div>
      <!--  withdraw card -->
      <div class="d-inline-block balance-box-2 pa-4 ml-8">
        <p class="secodry-text-2  fs-14">{{ $lang.CURRENT_BALANCE }}</p>
        <img alt="" src="@/assets/rupee.svg" width="20">
        <span class="sub-title-text fs-36">
				{{ current_balance }}
			</span>
      </div>
    </div>


    <!-- <span class="page-title"> {{$lang.WITHDRAWAL_HISTORY.toUpperCase()}}</span> -->
    <div class="my-4">
      <v-data-table
          :disable-sort="true"
          :headers="headers"
          :hide-default-footer="true"
          :items="shipment_list"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          class="elevation-1 custome-header-bg custome-table-body"
      >
        <template v-slot:item.status="{ item }">
          <span :class="'transaction_'+item.status.toLowerCase()">{{ item.status }}</span>
        </template>
        <template v-slot:item.retailer_firm_name="{ item }">
          <p>{{ item.retailer_firm_name }}</p>
          <p v-if="item.retailer_phone_number">{{ $lang.MOBILE_PREFIX }}{{ item.retailer_phone_number }}</p>
          <p>({{ item.retailer_location }})</p>
        </template>
        <template v-slot:item.shipment_amount="{ item }">
          <p v-if="item.type=='Collection'">{{ item.shipment_amount }}</p>
          <p v-else>0.00</p>
        </template>
        <template v-slot:item.type="{ item }">
			<span :class="item.type.toLowerCase()">
				{{ item.type }}
			</span>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn fab small text @click="gotoShipmentDetails(item)">
            <img alt="" src="@/assets/arrow-right.svg">
          </v-btn>
        </template>


      </v-data-table>

      <v-pagination v-model="page_number" :length="total_page_count" :total-visible="7" class="custome-pagination"
                    @input="getWithdrawalList"></v-pagination>

    </div>

    <confirm-withdrawal-dialog :dialog="dialog" @update-list="getWithdrawalList"/>
    <!-- <withdraw-verification-dailog :dialog="dialog"  @update-list="getWithdrawalList"/> -->

  </div>
</template>

<script type="text/javascript">
export default {
  components: {
    WholesalerSelectBox: () => import('@/components/common-components/WholesalerSelectBox.vue'),
    ConfirmWithdrawalDialog: () => import('@/components/wallet/child/ConfirmWithdrawalDialog.vue'),
    // WithdrawVerificationDailog:()=>import('./child/WithdrawVerificationDailog.vue')
  },
  data() {
    return {
      wholesaler: this.$store.state.initiate_withdrawal.wholesaler || null,
      return_count: 0,
      current_balance: 0,
      shipment_list: [],
      dialog: {
        flag: false,
        otp: "",
        item: {
          date: "",
          time: "",
          amount: "",
          mobile: "",
          returned_count: "",
          otp_token: "",
          wholesaler_firm_name: "",
        }
      },
      filter_dialog: {
        flag: false,
      },
      recipient_name: "",
      /* Table Elements */
      page_number: 1,
      table_loading: false,
      total_page_count: 1,
      headers: [
        {text: '#Transaction ID', align: 'start', sortable: false, value: 'shipment_id',},
        {text: 'Retailer info', value: 'retailer_firm_name'},
        {text: 'Challan', value: 'challan_number'},
        {text: 'Amount', value: 'shipment_amount'},
        {text: 'Packages', value: 'number_of_packets'},
        {text: 'Type', value: 'type'},
        {text: '', value: 'action'},
      ],
    }
  },
  created() {
    if (this.wholesaler)
      this.getWithdrawalList()
  },
  methods: {
    /* getching withdrala list filter by the wholesaler*/
    getWithdrawalList() {
      const self = this

      if (!self.wholesaler) {
        this.current_balance = 0
        this.return_count = 0
        this.shipment_list = []
        return false
      }

      this.$store.dispatch('setPageLoader', true)
      let wholesaler_id = null
      if (self.wholesaler)
        wholesaler_id = self.wholesaler.wholesaler_id
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        wholesaler_id: wholesaler_id,

      };
      self.table_loading = true

      const successHandler = (response) => {
        console.log(response)
        if (response.data.success) {
          // this.shipment_list=response.data.collection_list.concat(response.data.return_list)
          this.total_page_count = response.data.total_page_count

          /* adding extra keys for the  for collection  and Returns */

          let collection_list = response.data.collection_list
          let return_list = response.data.return_list
          collection_list.map(function (entry) {
            entry.type = 'Collection'//this.$keys.SHIPMENT_COLLECTION;
            return entry;
          });
          return_list.map(function (entry) {
            entry.type = "Returns"//this.$keys.SHIPMENT_RETURNS;
            return entry;
          });
          self.shipment_list = collection_list.concat(return_list)


          if (self.wholesaler) {
            this.current_balance = response.data.amount
            this.return_count = response.data.returned_count
          } else {
            this.current_balance = 0
            this.return_count = 0
          }
        }
      };
      const finallyHandler = () => {
        self.table_loading = false
        this.$store.dispatch('setPageLoader', false)
      };

      self.request_GET(self, self.$urls.WITHDRAWAL_HISTORY, params, successHandler, null, null, finallyHandler)
    },
    /* event trigger on the  wholesaler chnages*/
    getWholesaler(wholesaler) {
      this.wholesaler = wholesaler
      this.$store.state.initiate_withdrawal.wholesaler = wholesaler
      this.getWithdrawalList()

    },
    /* redirect to withdrawal details*/
    gotoWidthdrwalDetails(transaction_id) {
      console.log(transaction_id)
      this.$router.push({name: 'withdrawal-details', params: {'transaction_id': this.encript(transaction_id)}})
    },
    /* go to  the  withdrawal return list*/
    gotoReturnsList() {
      console.log(this.wholesaler)
      if (this.return_count > 0)
        this.$router.push({
          name: 'returns',
          query: {type: this.encript(this.$keys.RETURNS), wholesaler_id: this.encript(this.wholesaler.wholesaler_id)},
        })
    },
    /* go to the collection list*/
    gotoCollectionList() {
      if (this.current_balance > 0)
        this.$router.push({
          name: 'collections',
          query: {type: this.encript(this.$keys.COLLECTION), wholesaler_id: this.encript(this.wholesaler.wholesaler_id)}
        })
    },
    /* initiate withdrwal */
    initiateWithdrawal() {
      const self = this;
      if (this.return_count == 0 && this.current_balance == 0) {
        this.$store.dispatch('snackbar/setSnackbar', {flag: true, text: "Nothing to withdraw", color: "warning"})
        return false
      }


      var form = new FormData();
      form.append("recipient_name", self.recipient_name);
      form.append("wholesaler_id", self.wholesaler.wholesaler_id);
      const successHandler = (response) => {
        if (response.data.success) {
          this.transaction_id = response.data.id;
          this.dialog.item.date = response.data.created_date;
          this.dialog.item.time = response.data.created_time;
          this.dialog.item.amount = response.data.amount;
          this.dialog.item.mobile = response.data.wholesaler_mobile_number;
          this.dialog.item.returned_count = response.data.returned_count;
          this.dialog.item.wholesaler_firm_name = this.wholesaler.firm_name;
          this.dialog.otp = response.data.otp
          this.dialog.item.otp_token = response.headers["otp-token"]
          this.dialog.flag = true


        }
      };
      this.request_POST(self, this.$urls.INITIATE_WITHDRAW, form, successHandler)
    },
    show_dialog(item) {
      this.dialog.item = item
      this.dialog.flag = true
    }
  }
}
</script>